module.exports = __webpack_public_path__ + "img/download.32293d78.svg";